var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['visual-section', {'is-show': _vm.isReady}]},[_c('Canvas',[_c('Pointer',{attrs:{"slot":"pointer"},slot:"pointer"})],1),_c('Vr'),_c('Breadcrumbs'),_c('Rotate'),_c('Compass'),_c('Filters')],1)}
var staticRenderFns = []

export { render, staticRenderFns }